import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';

export function TermsAndConditionsPage() {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();

  const handleBack = () => {
    if (token) {
      navigate(`/${token}`, { replace: true });
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-8 px-4">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-6 mb-6">
          <button
            onClick={handleBack}
            className="flex items-center gap-2 text-sky-600 dark:text-sky-400 hover:text-sky-700 dark:hover:text-sky-300 transition-colors mb-4"
          >
            <ArrowLeft className="w-5 h-5" />
            Volver
          </button>
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-sky-100 dark:bg-sky-900/20 rounded-full flex items-center justify-center">
              <FileText className="w-6 h-6 text-sky-600 dark:text-sky-400" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
                Términos y Condiciones
              </h1>
              <p className="text-sm text-gray-500 dark:text-gray-400">
                Última actualización: Noviembre 2025
              </p>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8">
          <div className="prose dark:prose-invert max-w-none">
            <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-4">
              1. Aceptación de los Términos
            </h2>
            <p className="text-gray-700 dark:text-gray-300 mb-6">
              Al utilizar ComandaYa, aceptas estos términos y condiciones en su totalidad. Si no estás de acuerdo con estos términos, no debes utilizar nuestros servicios.
            </p>

            <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-4">
              2. Uso del Servicio
            </h2>
            <p className="text-gray-700 dark:text-gray-300 mb-4">
              ComandaYa es una plataforma que permite a los clientes de restaurantes y establecimientos gastronómicos realizar pedidos de manera digital. El servicio incluye:
            </p>
            <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 mb-6 space-y-2">
              <li>Visualización del menú digital</li>
              <li>Realización de pedidos</li>
              <li>Gestión de la cuenta de mesa</li>
              <li>Procesamiento de pagos</li>
            </ul>

            <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-4">
              3. Identificación del Usuario
            </h2>
            <p className="text-gray-700 dark:text-gray-300 mb-6">
              Para utilizar nuestro servicio, es necesario proporcionar un correo electrónico o número de teléfono. Esta información se utiliza únicamente para identificar tu sesión en la mesa y gestionar tus pedidos durante tu visita al establecimiento.
            </p>

            <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-4">
              4. Pedidos y Pagos
            </h2>
            <p className="text-gray-700 dark:text-gray-300 mb-6">
              Los pedidos realizados a través de ComandaYa son vinculantes. Una vez confirmado un pedido, este será enviado a la cocina o bar del establecimiento. Los precios mostrados en la aplicación son los vigentes al momento de realizar el pedido. Los pagos pueden realizarse mediante los métodos habilitados por el establecimiento.
            </p>

            <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-4">
              5. Responsabilidades
            </h2>
            <p className="text-gray-700 dark:text-gray-300 mb-4">
              El usuario se compromete a:
            </p>
            <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 mb-6 space-y-2">
              <li>Proporcionar información verdadera y precisa</li>
              <li>Utilizar el servicio de manera responsable</li>
              <li>Respetar las políticas del establecimiento</li>
              <li>Pagar los productos y servicios solicitados</li>
            </ul>

            <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-4">
              6. Limitación de Responsabilidad
            </h2>
            <p className="text-gray-700 dark:text-gray-300 mb-6">
              ComandaYa actúa como intermediario tecnológico entre el cliente y el establecimiento. La calidad de los productos, tiempos de preparación y servicio son responsabilidad exclusiva del establecimiento. ComandaYa no se hace responsable por problemas derivados de la calidad de los productos o el servicio del establecimiento.
            </p>

            <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-4">
              7. Modificaciones
            </h2>
            <p className="text-gray-700 dark:text-gray-300 mb-6">
              ComandaYa se reserva el derecho de modificar estos términos en cualquier momento. Los cambios entrarán en vigor al momento de su publicación en la plataforma.
            </p>

            <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-4">
              8. Contacto
            </h2>
            <p className="text-gray-700 dark:text-gray-300 mb-6">
              Para cualquier consulta relacionada con estos términos y condiciones, puedes contactarte con el establecimiento o con el soporte de ComandaYa.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
